import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-link-field-to-season',
    templateUrl: './link-field-to-season.component.html',
    styleUrls: ['./link-field-to-season.component.css'],
    standalone: false
})
export class LinkFieldToSeasonComponent implements OnInit {

  constructor(
    public matDialog: MatDialogRef<LinkFieldToSeasonComponent>,
  ) {
  }
  ngOnInit(): void {
  
  }

  
    cancel(): void {
      this.matDialog.close({"option": "cancel"});
    }
  
    link(): void {
      this.matDialog.close({"option": "link"});
    }
  }
